import '../App.css';
import Featured from '../components/Featured';
import Navbar from '../components/Navbar';
import Search from '../components/Search';
import Book from '../components/Book';
import Footer from '../components/Footer';


export default function Home({
    search, results, searchTerm, setSearchTerm, addToCart }) {


    const handleKeyDown = e => {
        if (e.key === 'Enter') search(searchTerm);
    }

    return (
        <>
            <p className='promo-banner'>
                Free Shipping On Orders Over $30!
            </p>
            <Navbar />
            <Search
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                search={search}
                handleKeyDown={handleKeyDown}
            />
            <Featured />
            
            <div className='results-container'>
                {(results.length) ?
                <span className='results'>
                    {results.map(item =>
                        <Book key={item.id} book={item} addToCart={addToCart}/>
                    )}
                </span>
                : <h1 className='home-no-results'>No Results</h1>
                }
                
            </div>
            <Footer />
        </>
    )

}
